import { useQuery } from '@tanstack/react-query'
import { SipRecommendationActionType } from '../api/common.types'
import { SIP_PLANS_API_RETRY_COUNT, isSipQueryFetchFailed, isSipQueryLoading } from '../api/queryOptions'
import { fetchSipPlanRecommendation } from './api/repository'
import type { SipPlanRecommendationDetails } from './api/sipPlanRecommendation.types'

export function useSipPlanRecommendation(
  isin: string,
  recommendationAction: SipRecommendationActionType,
  totalIdealSipAmount: number,
  enabled: boolean
): {
  planDetails: SipPlanRecommendationDetails | null
  isLoading: boolean
  isFetchFailed: boolean
  onRetry: () => void
} {
  const query = useQuery({
    queryKey: ['sip-plans-v4-recommendation', recommendationAction, isin, totalIdealSipAmount],
    queryFn: () => fetchSipPlanRecommendation(isin, recommendationAction),
    enabled: enabled && isin.length > 0,
    retry: SIP_PLANS_API_RETRY_COUNT
  })

  return {
    planDetails: query.data ?? null,
    isLoading: isSipQueryLoading(query),
    isFetchFailed: isSipQueryFetchFailed(query),
    onRetry: () => {
      void query.refetch()
    }
  }
}
